export const STATS = {
    // Home page
    all: {
        anchors: 178,
        borrowers: 18791,
        invoices: 429581,
        disbursed: 46022324144.33,
        aum: 3792697000.0,
    },
    // SaralPay Later
    bnpl: {
        anchors: 27,
        borrowers: 1947,
        invoices: 16636,
        disbursed: 12469127229.75,
        aum: 409557000.0,
    },
    // Vendor Finance
    vendor: {
        anchors: 13,
        borrowers: 93,
        invoices: 696,
        disbursed: 12692457170.7,
        aum: 1375545000.0,
    },
    // Supplychain finance
    scf: {
        anchors: 30,
        borrowers: 30,
        invoices: 1490,
        disbursed: 20860739743.88,
        aum: 2007595000.0,
    },
};
